import React, { useState, useMemo, useEffect } from "react";
import { Table, Input, Select, Card, Tag, Avatar } from "antd";
import {
  SearchOutlined,
  TrophyOutlined,
  ClockCircleOutlined,
  IdcardOutlined,
} from "@ant-design/icons";

import "./LuckyRawWinners.less";
import { useTranslation } from "react-i18next";
import useGetProjects from "commons/hooks/useGetProjects";
import useGetRealTimeBookingWonPrize from "signalr/useGetRealTimeBookingWonPrize";
import LanguageSwitcher from "commons/components/common/LanguageSwitcher";
import logoLocPhat from "../../assets/images/Logo quoc Loc Phat-02.png";
import logo from "../../assets/images/logo.png";

const { Option } = Select;

export const LuckyRawWinners = () => {
  const { t } = useTranslation();

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProject, setSelectedProject] = useState();
  // eslint-disable-next-line no-unused-vars
  const [dateRange, setDateRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { projects: projectsData = [] } = useGetProjects();

  const formattedDateRange = useMemo(() => {
    return dateRange
      ? {
          from: dateRange[0]?.toISOString(),
          to: dateRange[1]?.toISOString(),
        }
      : null;
  }, [dateRange]);

  const {
    data: bookingWonPrizeData,
    loading: bookingWonPrizeLoading,
    networkConnected: connected,
  } = useGetRealTimeBookingWonPrize({
    projectId: selectedProject,
    searchTerm: searchTerm,
    formattedDateRange: formattedDateRange,
    // null, // stt nếu có
    pageSize: 999,
    currentPage: currentPage,
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedProject, dateRange]);

  useEffect(() => {
    if (projectsData.length > 0) {
      setSelectedProject(projectsData[0].id);
    }
  }, [projectsData]);

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) {
      return {
        date: "",
        time: "",
      };
    }
    const date = new Date(dateTimeString);
    return {
      date: date.toLocaleDateString("vi-VN"),
      time: date.toLocaleTimeString("vi-VN", { hour12: false }),
    };
  };

  const columns = [
    {
      title: (
        <div className="column-header" style={{ justifyContent: "center" }}>
          <TrophyOutlined className="column-icon" />
          <span className="order-badge-title">
            {t("winners.columns.winOrder")}
          </span>
        </div>
      ),
      key: "winOrder",
      width: 32,
      align: "center",
      render: (_, record) => {
        const winOrder = record?.booking?.orderNumber;
        return (
          <div className="win-order-badge">
            <Avatar size={36} className="win-order-avatar">
              {winOrder}
            </Avatar>
          </div>
        );
      },
    },
    {
      title: (
        <div className="column-header">
          <IdcardOutlined className="column-icon" />
          <span>{t("winners.columns.bookingCode")}</span>
        </div>
      ),
      dataIndex: "bookingCode",
      key: "bookingCode",
      width: 160,
      render: (_, record) => {
        const bookingCode = record?.booking?.bookingCustomId;
        return (
          <Tag color="blue" className="booking-code-tag">
            {bookingCode.toUpperCase()}
          </Tag>
          // <Tag color="blue" className="booking-code-tag">CPL/MTP/11</Tag>
        );
      },
    },
    {
      title: (
        <div className="column-header">
          <ClockCircleOutlined className="column-icon" />
          <span>{t("winners.columns.winTime")}</span>
        </div>
      ),
      dataIndex: "winTime",
      key: "winTime",
      width: 250,
      render: (_, record) => {
        const { date, time } = formatDateTime(record?.bookingWonPrizeTime);
        return (
          <div className="time-info">
            <div className="win-date">{date.toUpperCase()}</div>
            <div className="win-time">{time.toUpperCase()}</div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="lucky-winners-container">
      {/* <Header /> */}

      <div className="lucky-winners-content">
        <Card className="filters-card">
          <div className="filters-grid">
            <div className="filters-header">
              <div className="logo">
                {/* <Link className="navbar-brand" to="/"> */}
                <div className="navbar-brand">
                  <img className="logo_img" src={logoLocPhat} alt="logo" />
                  <img className="logo_img" src={logo} alt="logo" />
                </div>
                {/* </Link> */}
              </div>
              <LanguageSwitcher />
            </div>
            <div className="filters-input">
              <Input
                className="search-input"
                placeholder={t("winners.searchPlaceholder")}
                prefix={<SearchOutlined />}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                allowClear
              />
              <Select
                className="project-select"
                placeholder={t("winners.selectProject")}
                value={selectedProject}
                onChange={(value) => setSelectedProject(value)}
                allowClear
                dropdownMatchSelectWidth={false}
              >
                {projectsData.map((project) => (
                  <Option key={project?.id} value={project?.id}>
                    {project?.name}
                  </Option>
                ))}
              </Select>
              {/* <RangePicker
                            className="time-selector"
                            // style={{ width: '100%' }}
                            showTime
                            value={dateRange}
                            onChange={(dates) => setDateRange(dates)}
                            placeholder={[t("winners.columns.winTime"), t("winners.columns.winTime")]}
                        /> */}
            </div>
          </div>
        </Card>
        <Card className="main-table">
          <Table
            columns={columns}
            dataSource={bookingWonPrizeData}
            rowKey="id"
            pagination={false}
            loading={bookingWonPrizeLoading}
            scroll={{ x: 1000, y: "80vh" }}
            rowClassName={(record) => {
              let classList = "";
              // const status = record.booking?.status;
              // const prizeTimeString = record?.expiredTime;
              // const now = new Date();

              // // if (status === BookingStatus.SELECTIONCOMPLETED) {
              // //     classList += ' success-row';
              // // } else if (status === BookingStatus.SELECTIONEXPIRED) {
              // //     classList += ' expired-row';
              // // } else if (
              // //     prizeTimeString &&
              // //     new Date(prizeTimeString) > now
              // // ) {
              // //     classList += ' join-selection-row';
              // // } else if (status === BookingStatus.SELECTIONSENT) {
              // //     classList += ' selection-sent-row';
              // // }

              return classList.trim();
            }}
            locale={{
              emptyText: (
                <div style={{ textAlign: "center", width: "100%" }}>
                  <img
                    src={logo}
                    alt="No Data"
                    style={{ width: "20%", marginBottom: 16 }}
                  />
                  <p>{t("winners.noDataPlayholder")}</p>
                </div>
              ),
            }}
          />
          {!connected && (
            <div className="lucky-winners-disconnect">
              <div className="disconnect-overlay">
                <div className="disconnect-content">
                  <div className="disconnect-spinner">
                    <div className="spinner"></div>
                  </div>
                  <div className="disconnect-text">
                    <h3>{t("winners.reconnecting")}</h3>
                    <p>{t("winners.reconnectingMessage")}</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};
